// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AX58","placeholdersHeader":"styles_placeholdersHeader__35At8","editorStyle":"styles_editorStyle__1SiBJ","placeholdersBox":"styles_placeholdersBox__eVXVw"};